<template>
  <section class="gry-bg py-5">
    <div class="profile">
      <div class="container">
        <div class="row">
          <div class="col-xxl-4 col-xl-5 col-lg-6 col-md-8 mx-auto">
            <div class="card">
              <div class="text-center pt-4">
                <h1 class="h4 fw-600">{{ $t("登录") }}</h1>
              </div>
              <!--              email("邮箱"),-->
              <!--              phone("手机号"),-->
              <!--              username("用户名_账号"),-->
              <!--              password("登录密码"),-->
              <div class="px-4 py-3 py-lg-4">
                <van-form style="margin-bottom: 1rem" @submit="login">
                  <van-field
                      v-if="`,${paramMapAll['LOGIN_PROPS']},`.includes(',email,')"
                      v-model="loginForm.username"
                      :placeholder="$t('邮箱')"
                      :rules="[
                      {
                        required: true
                      }
                    ]"
                      center
                      class="text-center"
                      clearable
                      label=""
                      size="large"
                  />
                  <van-field
                      v-model="loginForm.username"
                      v-if="`,${paramMapAll['LOGIN_PROPS']},`.includes(',username,')"
                      :placeholder="$t('用户名')"
                      :rules="[
                      {
                        required: true
                      }
                    ]"
                      center
                      class="text-center"
                      clearable
                      label=""
                      size="large"
                  />
                  <van-field
                      v-if="`,${paramMapAll['LOGIN_PROPS']},`.includes(',phone,')"
                      v-model="loginForm.username"
                      :placeholder="$t('手机号')"
                      :rules="[
                      {
                        required: true
                      }
                    ]"
                      center
                      class="text-center"
                      clearable
                      label=""
                      size="large"
                  />
                  <van-field
                      v-if="`,${paramMapAll['LOGIN_PROPS']},`.includes(',password,')"
                      v-model="loginForm.password"
                      :placeholder="$t('密码')"
                      :rules="[
                      {
                        required: true
                      },
                      // {
                      //   pattern: /^.{6,16}$/,
                      //   message: $t('密码长度为6_16个字符'),
                      //   trigger: 'blur'
                      // }
                    ]"
                      center
                      class="text-center mt-2"
                      clearable
                      label=""
                      size="large"
                      type="password"
                  />
<!--                  v-if="`,${paramMapAll['LOGIN_PROPS']},`.includes(',captcha,')"-->
                  <van-field
                      v-if="captchaOpen"
                      v-model="loginForm.captcha"
                      :placeholder="$t('验证码')"
                      :rules="[
                      {
                        required: true,
                        message: $t('验证码')
                      }
                    ]"
                      class="mt-2"
                      type="number"
                  >
                    <template #button>
                      <img
                          :src="codeImg"
                          style="height: 24px; margin-top: 4px"
                          @click.stop="createCode"
                      />
                    </template>
                  </van-field>
                  <div class="row my-2 mx-1">
                    <div class="col-6">
                      <label class="aiz-checkbox">
                        <input name="remember" type="checkbox"/>
                        <span class="opacity-60">{{ $t("记得我") }}</span>
                        <span class="aiz-square-check"></span>
                      </label>
                    </div>
                    <div class="col-6 text-right">
                      <router-link
                          class="text-reset opacity-60 fs-14"
                          to="/password/reset"
                      >
                        {{ $t("忘记密码") }}？
                      </router-link>
                    </div>
                  </div>
                  <van-button
                      :loading="loading"
                      :loading-text="$t('登录中')"
                      block
                      class="btn"
                      native-type="submit"
                      round
                      small
                      type="primary"
                  >
                    {{ $t("登录") }}
                  </van-button>
                  <van-button
                      v-if="paramMapAll['DEMO_LOGIN_OPEN'] === '1'"
                      :loading="YK_loading"
                      :loading-text="$t('登录中')"
                      block
                      class="mt-2"
                      native-type="submit"
                      plain
                      round
                      small
                      type="primary"
                      @click="loginGuest"
                  >{{ $t("游客登录") }}
                  </van-button>
                </van-form>
                <div   v-if="`,${paramMapAll['HOME_BUYER_SHOW']},`.includes(',登录页_注册店铺,')" class="text-center">
                  <p class="text-muted mb-0">
                    {{ $t("注册您的商店") + "?" }}
                  </p>
                  <router-link to="/shops/create"
                  >{{ $t("现在申请") }}
                  </router-link>
                </div>
                <div class="text-center">
<!--                  <p class="text-muted mb-0">{{ $t("没有帐户") }}？</p>-->
                  <router-link to="/register">{{ $t("现在注册") }}</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import {getToken, setToken} from "@/utils/auth";

export default {
  name: "LoginView",
  computed: {
    ...Vuex.mapGetters(["paramMapAll"])
  },
  data() {
    return {
      loading: false,
      YK_loading: false,
      loginForm: {},
      captchaOpen: false,
      codeImg: null,
      showLanguagePop: false
    };
  },
  created() {
    this.captchaOpen = "1" === this.paramMapAll["LOGIN_CAPTCHA_OPEN"];
    if (this.captchaOpen) {
      this.createCode();
    }
  },
  methods: {
    createCode() {
      this.codeImg = this.getVerifyCode("LOGIN_CAPTCHA_OPEN");
    },
    loginGuest() {
      this.$store
          .dispatch("user/loginGuest", this.loginForm)
          .then(() => {
            this.YK_loading = false;
            this.$toast.success(this.$t("登录成功"));
            this.$router.push({path: "/"});
          })
          .catch(() => {
            this.YK_loading = false;
          });
    },
    getRootDomain(url) {
      const urlObject = new URL(url);
      const parts = urlObject.hostname.split('.');
      const rootDomainParts = parts.slice(-2);
      return rootDomainParts.join('.');
    },
    login() {
      this.loading = true;
      this.$store
          .dispatch("user/login", this.loginForm)
          .then(userInfo => {
            this.loading = false;
            this.$toast.success(this.$t("登录成功"));
            if (userInfo.isShopUser) {
              let token = getToken()
              console.log('token', token)
              token && setToken(token)
              window.location.href = this.paramMapAll['SHOP_SELLER_TO_BUYER_FORCE_BACK']!=='0' ? this.sellerSiteAddress :'/'
            } else {
              let path = Cookies.get("redirectPath");
              Cookies.set("redirectPath", "");
              this.$router.push({path: path || "/"});
            }
          })
          .catch(() => {
            this.loading = false;
          });
    }
  }
};
</script>
